import { Component, OnInit } from '@angular/core';
import {FormGroup, Validators, FormBuilder} from '@angular/forms';
import { Router } from '@angular/router';
import {AuthService} from '../../../core/services/auth.service';
import {HttpRequestService} from '../../../core/services/http-request.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted: boolean;
  disabled: boolean;
  httpError: string;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpRequestService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$')]],
      password: ['', Validators.required]
    });
  }

  signIn() {
    this.submitted = true;
    const self = this;

    if (this.loginForm.valid) {
      this.http.post('login', this.loginForm.controls).subscribe(loginData => {
        if (loginData['is_first_login']) {
          this.router.navigate(['/reset-password/true/' + self.loginForm.get('email').value]);
        } else {
          localStorage.setItem('accessToken', loginData.idToken);
          localStorage.setItem('refreshToken', loginData.refreshToken);
          localStorage.setItem('email', loginData.email);
          localStorage.setItem('hasPrc', "false");
          localStorage.setItem('view_filter', "me");

          this.http.get('advisors?email=' + loginData.email + '&status=true').subscribe(userData => {
            if(userData.length > 0){
              localStorage.setItem('username', userData[0]['advisor_name'] + ' ' + userData[0]['advisor_last_name']);
            localStorage.setItem('enabled', 'true');
            localStorage.setItem('pem', userData[0].role_id);
            localStorage.setItem('photo', userData[0]['advisor_image_url']);
            localStorage.setItem('isFirstLogin', userData[0]['is_first_login']);
            localStorage.setItem('advisor_id', userData[0]['advisor_id']);
            localStorage.setItem('advisor_code', userData[0]['advisor_code']);
            this.http.get('advisors/'+userData[0]['advisor_id']+'/prc').subscribe(advisorData => {
               if(advisorData.length > 0){
                  console.log("entro");
                  localStorage.setItem('hasPrc', "true");
                  localStorage.setItem('prc_id', advisorData[0]['prc_id']);
                  localStorage.setItem('prcLocation', advisorData[0]['location']);
                  this.router.navigate(['/dashboard']);

               } else {
                this.router.navigate(['/dashboard']);
               }

            });

            
            }
          });
        }
      });
    }
  }
}
